var installedModules = {};
var moduleToHandlerMapping = {
	8081: {
		getter: function() { return __webpack_require__.e(774).then(function() { return function() { return __webpack_require__(5893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	1568: {
		getter: function() { return __webpack_require__.e(8).then(function() { return function() { return __webpack_require__(9008); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	1594: {
		getter: function() { return Promise.all([__webpack_require__.e(372), __webpack_require__.e(288), __webpack_require__.e(163), __webpack_require__.e(842)]).then(function() { return function() { return __webpack_require__(1163); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	8371: {
		getter: function() { return Promise.all([__webpack_require__.e(372), __webpack_require__.e(664)]).then(function() { return function() { return __webpack_require__(1664); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	9094: {
		getter: function() { return Promise.all([__webpack_require__.e(288), __webpack_require__.e(842), __webpack_require__.e(951)]).then(function() { return function() { return __webpack_require__(4298); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	4977: {
		getter: function() { return Promise.all([__webpack_require__.e(675), __webpack_require__.e(842)]).then(function() { return function() { return __webpack_require__(5675); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	8477: {
		getter: function() { return __webpack_require__.e(152).then(function() { return function() { return __webpack_require__(5152); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	4053: {
		getter: function() { return __webpack_require__.e(774).then(function() { return function() { return __webpack_require__(7294); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	5739: {
		getter: function() { return __webpack_require__.e(130).then(function() { return function() { return __webpack_require__(6130); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	8882: {
		getter: function() { return __webpack_require__.e(525).then(function() { return function() { return __webpack_require__(525); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	3470: {
		getter: function() { return __webpack_require__.e(774).then(function() { return function() { return __webpack_require__(745); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	6842: {
		getter: function() { return __webpack_require__.e(774).then(function() { return function() { return __webpack_require__(3935); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	6753: {
		getter: function() { return Promise.all([__webpack_require__.e(505), __webpack_require__.e(842)]).then(function() { return function() { return __webpack_require__(7691); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.30",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-react-utils",
	},
	4711: {
		getter: function() { return __webpack_require__.e(971).then(function() { return function() { return __webpack_require__(1636); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.102",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-auth-react",
	},
	2009: {
		getter: function() { return __webpack_require__.e(63).then(function() { return function() { return __webpack_require__(1664); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	9463: {
		getter: function() { return __webpack_require__.e(8).then(function() { return function() { return __webpack_require__(9008); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	4476: {
		getter: function() { return __webpack_require__.e(480).then(function() { return function() { return __webpack_require__(4480); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.109",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-auth-react",
	},
	4218: {
		getter: function() { return __webpack_require__.e(152).then(function() { return function() { return __webpack_require__(5152); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	}
};
var initialConsumes = [8081,1568,1594,8371,9094,4977,8477,4053,5739,8882,4053,3470,6842,8081,1594,6753,4711,2009,9463,4476,4218];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"81": [
		8081
	],
	"137": [
		1568,
		1594,
		8371,
		9094,
		4977,
		8477,
		4053,
		5739,
		8882
	],
	"179": [
		4053,
		3470,
		6842
	],
	"229": [
		4218
	],
	"476": [
		4476
	],
	"753": [
		6753
	],
	"842": [
		6842
	],
	"888": [
		8081,
		1594,
		6753,
		4711,
		2009,
		9463
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}